export default "__VITE_ASSET__BIBy$B89__"